// Pure data model + merge for the member-organizations listing, shared by the topbar switcher and
// the /me launchpad. No React/Descope imports so it is trivially unit-testable.
const collator = new Intl.Collator(undefined, { sensitivity: "base", numeric: true });
function byName(a, b) {
    return collator.compare(a.name, b.name) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
}
function makeGroup(id, name, liveblogOrgs, nxtOrgs) {
    const canManage = liveblogOrgs.some((org) => org.role === "owner" || org.role === "admin") ||
        nxtOrgs.some((org) => org.accessLevel === "admin");
    return {
        id,
        name,
        liveblogOrgs: [...liveblogOrgs].sort(byName),
        nxtOrgs: [...nxtOrgs].sort(byName),
        canManage,
    };
}
/**
 * Merge liveblog tenants (gatekeeper) and nxt-cms Organizations (management) into one per–Descope-
 * tenant grouping, matched by `descopeId`. Neither backend sorts, so the order is made deterministic
 * here: tenant groups alphabetically by resolved name, and each group's Organizations alphabetically
 * by name. The group name prefers the liveblog tenant name, then the nxt-cms-resolved tenant name,
 * then the descopeId.
 */
export function buildTenantGroups(liveblogTenants, nxtOrgs) {
    const nxtByDescopeId = new Map();
    for (const org of nxtOrgs) {
        const existing = nxtByDescopeId.get(org.descopeId);
        if (existing)
            existing.push(org);
        else
            nxtByDescopeId.set(org.descopeId, [org]);
    }
    const groups = [];
    const seen = new Set();
    for (const tenant of liveblogTenants) {
        const nxt = nxtByDescopeId.get(tenant.id) ?? [];
        groups.push(makeGroup(tenant.id, tenant.name ?? nxt[0]?.tenantName ?? tenant.id, tenant.organizations, nxt));
        seen.add(tenant.id);
    }
    for (const [descopeId, orgs] of nxtByDescopeId) {
        if (seen.has(descopeId))
            continue;
        groups.push(makeGroup(descopeId, orgs[0]?.tenantName ?? descopeId, [], orgs));
    }
    return groups.sort(byName);
}
//# sourceMappingURL=organizationGroups.js.map